import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent implements OnInit, OnDestroy {
  @Input() set url(value) {
    if (value) {
      this.uri = value;
      this.getData();
    }
  }
  @Input() hiddeDelete: boolean = false;
  @Input() set productId(value) {
    if (value) {
      setTimeout(() => {
        this.id = value;
        this.products = [];
        this.page = 1;
        this.getData();
      });
    }
  }
  @Output() product = new EventEmitter();
  @Output() loadedData = new EventEmitter();

  public id = undefined;
  public products: any[] = [];
  public uri = '';
  public page = 1;
  public totalPages = 1;
  public savedIndex = undefined;
  public search = '';
  private _subscription: Subscription = new Subscription();

  constructor(
    private httpSv: HttpService,
    private formSv: FormServices,
    private navCtrl: NavController
  ) {}

  ngOnInit() {
    this._subscription.add(
      this.formSv.deleteListProductObs.subscribe(async (id) => {
        if (id === 'reloadListProduct') {
          // this.page = 1;
          this.products = [];
          this.getData();
          return;
        }
        const index = this.products.findIndex((item) => item.id === id);
        this.products.splice(index, 1);
      })
    );
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  emitProduct(product, action, index) {
    if (index !== this.savedIndex) {
      this.savedIndex = index;
      this.product.emit({ product, action, changeAction: false });
    } else {
      this.product.emit({ product, action, changeAction: true });
    }
  }

  async getData() {
    try {
      const params = {
        pag: this.page,
        search: this.search,
        id: this.id || '',
      };
      const res: any = await this.httpSv.itemIndex(this.uri, '', params);
      if (this.id) {
        this.id = undefined;
        this.navCtrl.navigateRoot('admin/products');
      }
      const products = res.data?.data;

      if (this.uri === 'catalogues') {
        products.forEach((x) => {
          x.name = x.title;
        });
      }
      this.products = products;
      this.totalPages = res.data.meta.last_page;
      this.products.forEach((item) => {
        if (item.file) {
          !item.media && (item.media = []);
          item.media.push({ file: item.file });
        }
      });
      this.loadedData.emit();
    } catch (err) {
      console.error(err);
    }
  }

  searchProduct(ev) {
    this.search = ev?.value || '';
    this.products = [];
    this.page = 1;
    this.getData();
  }

  loadData(event) {
    this.page = event;
    this.getData();
  }
}
